import { useMemo } from "react"
import { useLocation } from "react-router-dom"

export function useAtlasRelativeUrl(): string | undefined {
  const { search } = useLocation()

  return useMemo(() => {
    const queryParams: URLSearchParams = new URLSearchParams(search)
    return queryParams.get("atlasRelativeUrl") || undefined
  }, [search])
}
